import React, { Component, Fragment } from "react";
import OrganizationHeader from "./OrganizationHeader";
import GetNotifiedPopup from "./GetNotifiedPopup";
import "./styles/base.css";
import PhotosContainer from "./PhotosContainer";
import { Cart, Tag } from "./types";
import {
  getCookie,
  setCookie,
  getParameterByName,
  deleteCookie
} from "../../utils/BrowserHelper";
import _ from "lodash";
import EventsContainer from "./EventsContainer";
import SearchOptions from "./SearchOptions";
const mobilePreview = require("./images/mobilePreview.png");
const mobilePrev = require("./images/mobilePrev.svg");
const desktopPrev = require("./images/DesktopPrev.svg");
import LazyLoad from "react-lazyload";
import SellYourPhotos from "../common/SellYourPhotosModal";
import { securedEventPath } from "../../utils/pathUtils";

export type Filters = {
  referenceImage: string | null;
  eventName: string;
  location: string;
  tags: Tag[];
};

export type Event = {
  id: number;
  slug: string;
  name: string;
  startDate: Date;
  browsePhotosPath: string;
  coverPhoto: string;
  location: string;
  state: string;
  fullAdress: string;
  country: string;
  [key: string]: any;
  searchableAddress: string;
  bookedByUserId: number;
  passwordProtected: boolean;
  day: string;
  month: string;
  year: string;
};

export type PageConfiguration = {
  showHeader: boolean;
  bannerUrl: string | null;
  croppedBannerURL: string | null;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
};

interface OrganizationEventsProps {
  customizePage: boolean;
  eventsURL: string;
  completedEventsAvailable: boolean;
  upcomingEventsCount: Number;
  organizerUserName: string;
  organizerEmail: string;
  bulkRegisterCustomerLeadAPI: string;
  pageConfiguration: PageConfiguration;
  editMode: boolean;
  eventsView: string;
  organizationName: string;
  embedMode: boolean;
  isEventOrganizer: boolean;
  createEventURL: string;
  showCreateEventBanner: boolean;
  cartId: string;
  adminUser: boolean;
  selfieSearchS3Bucket: string;
  currentUserId: number;
  currentUserCountry: string;
  cart: Cart;
  photosAPI: string;
  addToCartAPI: string;
  removeFromCartAPI: string;
  organizationId: number;
  secureAccessToken: string | null;
  isAuthorizedForDirectDownloads: boolean;
  landingPageURL?: string;
  eventsAvailable: boolean;
  updateEventCoverAPI: string;
  canManageTags: boolean;
  organizerId: number;
  selfieSearchAvailable: boolean;
  showSellYourPhotosModal: boolean;
  securedGalleryView: boolean;
  registerGuestUserAPI: string;
  directDownloadEnabled: boolean;
}

interface OrganizationEventsState {
  upcomingEventsView: boolean;
  customerSelectedEvent: Event | null;
  selfieUploadPopup: boolean;
  filters: Filters;
  clearSearch: boolean;
  previewMode: boolean;
  mobilePreview: boolean;
  desktopScreen: boolean;
  showSellYourPhotosPopup: boolean;
  guestUserId: number | null;
}

export const PageConfigurationContext =
  React.createContext<PageConfiguration | null>(null);

export const PageConfigurationContextConsumer =
  PageConfigurationContext.Consumer;

class OrganizationEvents extends Component<
  OrganizationEventsProps,
  OrganizationEventsState
> {
  constructor(props: OrganizationEventsProps) {
    super(props);
    this.state = {
      upcomingEventsView: props.eventsView == "upcoming",
      customerSelectedEvent: null,
      selfieUploadPopup: false,
      filters: {
        referenceImage: getCookie("reference_image") || null,
        eventName: "",
        location: "",
        tags: []
      },
      clearSearch: false,
      previewMode: window.location.href.includes("preview=true"),
      mobilePreview: false,
      desktopScreen: false,
      showSellYourPhotosPopup: false,
      guestUserId: null
    };

    window.addEventListener("popstate", e => {
      if (e.state === "upcoming") {
        this.setState({ upcomingEventsView: true });
      } else {
        this.setState({ upcomingEventsView: false });
      }
    });

    this.showUpcomingEvents = this.showUpcomingEvents.bind(this);
    this.showCompletedEvents = this.showCompletedEvents.bind(this);
    this.showGetNotifiedPopup = this.showGetNotifiedPopup.bind(this);
    this.eventPath = this.eventPath.bind(this);
    this.imageUploaded = this.imageUploaded.bind(this);
    this.tagsApplied = this.tagsApplied.bind(this);
    this.clearAllSearchFilters = this.clearAllSearchFilters.bind(this);
    this.setMobilePreview = this.setMobilePreview.bind(this);
  }

  componentDidMount() {
    if (getParameterByName("hide_navbar")) {
      document
        .getElementsByClassName("navbar")[0]
        .classList.add("gallery-m-preview");
      document
        .getElementsByClassName("dv-maincontent-wrap")[0]
        .classList.add("gallery-padding");
    }
    window.addEventListener("resize", this.setDesktopScreen.bind(this));
    $("body").on("contextmenu", function (e) {
      return false;
    });
    this.setDesktopScreen();
  }

  setGuestUserId = (guestUserId: number) => {
    this.setState({ guestUserId: guestUserId });
  };

  setDesktopScreen() {
    if (window.innerWidth < 770) {
      this.setState({ desktopScreen: false });
    } else this.setState({ desktopScreen: true });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.setDesktopScreen.bind(this));
  }

  setMobilePreview = () =>
    this.setState({ mobilePreview: !this.state.mobilePreview });

  renderMobilePreview = () => (
    <div className="white-screen">
      <img src={mobilePreview} />
      <div className="mobile-preview">
        <iframe
          src={`${this.props.landingPageURL}?&hide_navbar=true`}
          width={322}
          height={654}
          style={{ border: "none" }}
        ></iframe>
      </div>
    </div>
  );

  renderContainerLogic = () =>
    this.showMatchingPhotos() ? (
      <PageConfigurationContext.Provider
        value={{ ...this.props.pageConfiguration }}
      >
        <PhotosContainer
          //@ts-ignore
          currentUserId={this.props.currentUserId || this.state.guestUserId}
          cart={this.props.cart}
          filters={this.state.filters}
          tagsValue={this.state.filters.tags
            .map((tag: Tag) => tag.name)
            .join("")}
          photosAPI={this.props.photosAPI}
          addToCartAPI={this.props.addToCartAPI}
          removeFromCartAPI={this.props.removeFromCartAPI}
          isEventOrganizer={this.props.isEventOrganizer}
          organizationName={this.props.organizationName}
          organizationId={this.props.organizationId}
          embedMode={this.props.embedMode}
          isAuthorizedForDirectDownloads={
            this.props.isAuthorizedForDirectDownloads
          }
          secureAccessToken={this.props.secureAccessToken}
          removeTag={this.removeTag}
          canManageTags={this.props.canManageTags}
          securedOrgView={this.props.securedGalleryView}
          registerGuestUserAPI={this.props.registerGuestUserAPI}
          setGuestUserId={this.setGuestUserId}
          directDownloadEnabled={this.props.directDownloadEnabled}
        />
      </PageConfigurationContext.Provider>
    ) : (
      <LazyLoad height={200} offset={200} scrollContainer="#body-wrapper">
        <EventsContainer
          eventsURL={this.props.eventsURL}
          completedEventsAvailable={this.props.completedEventsAvailable}
          upcomingEventsCount={this.props.upcomingEventsCount}
          bulkRegisterCustomerLeadAPI={this.props.bulkRegisterCustomerLeadAPI}
          showGetNotifiedPopup={this.showGetNotifiedPopup}
          eventPath={this.eventPath}
          editMode={this.props.editMode}
          upcomingEventsView={this.state.upcomingEventsView}
          showUpcomingEvents={this.showUpcomingEvents}
          showCompletedEvents={this.showCompletedEvents}
          keywordFilters={this.keywordFilters()}
          clearAllSearchFilters={this.clearAllSearchFilters}
          updateEventCoverAPI={this.props.updateEventCoverAPI}
          eventsAvailable={this.props.eventsAvailable}
          organizationName={this.props.organizationName}
          organizationId={this.props.organizationId}
          secureAccessToken={this.props.secureAccessToken}
          selfieSearchS3Bucket={this.props.selfieSearchS3Bucket}
        />
      </LazyLoad>
    );

  renderHeaderView = () => (
    <Fragment>
      <OrganizationHeader
        editMode={this.props.editMode}
        bannerUrl={this.props.pageConfiguration.bannerUrl}
        croppedBannerURL={this.props.pageConfiguration.croppedBannerURL}
        organizationName={this.props.organizationName}
        embedMode={this.props.embedMode}
        isEventOrganizer={this.props.isEventOrganizer}
        desktopScreen={this.state.desktopScreen}
      />
      <SearchOptions
        selfieUploadPopup={this.state.selfieUploadPopup}
        toggleSelfieUploadPopup={this.toggleSelfieUploadPopup}
        imageThumbnail={this.state.filters.referenceImage}
        removeSelfie={this.removeSelfie}
        updateEventFilter={this.updateEventFilter}
        updateLocationFilter={this.updateLocationFilter}
        updateImageFilter={this.updateImageFilter}
        addTagToFilter={this.addTagToFilter}
        adminUser={this.props.adminUser}
        selfieSearchS3Bucket={this.props.selfieSearchS3Bucket}
        currentUserId={this.props.currentUserId}
        currentUserCountry={this.props.currentUserCountry}
        clearSearch={this.state.clearSearch}
        resetClearSearch={() => this.setState({ clearSearch: false })}
        canManageTags={this.props.canManageTags}
        selfieSearchAvailable={this.props.selfieSearchAvailable}
        pageConfiguration={this.props.pageConfiguration}
        openSellYourPhotos={() =>
          this.setState({ showSellYourPhotosPopup: true })
        }
        showSellYourPhotosBtn={this.props.showSellYourPhotosModal}
      />
    </Fragment>
  );

  renderOrgGalleryView = () => (
    <PageConfigurationContext.Provider
      value={{ ...this.props.pageConfiguration }}
    >
      {this.props.upcomingEventsCount > 0 ||
      this.props.completedEventsAvailable ||
      this.props.editMode
        ? this.renderHeaderView()
        : null}
      {this.renderContainerLogic()}
      {this.state.customerSelectedEvent && (
        <GetNotifiedPopup
          events={[this.state.customerSelectedEvent]}
          bulkRegisterCustomerLeadAPI={this.props.bulkRegisterCustomerLeadAPI}
          clearSelection={() => {
            this.setState({ customerSelectedEvent: null });
          }}
        />
      )}
      {this.state.showSellYourPhotosPopup ? (
        <SellYourPhotos
          handleCloseClick={() =>
            this.setState({ showSellYourPhotosPopup: false })
          }
        />
      ) : null}
    </PageConfigurationContext.Provider>
  );

  public render() {
    return (
      <Fragment>
        <div className="org-gallery-container v3-org-gallery-container">
          {this.state.previewMode && this.state.desktopScreen && (
            <button
              className="previewbtn"
              onClick={() => this.setMobilePreview()}
            >
              {" "}
              PREVIEW
              <img src={this.state.mobilePreview ? mobilePrev : desktopPrev} />
            </button>
          )}
          {this.state.mobilePreview
            ? this.renderMobilePreview()
            : this.renderOrgGalleryView()}
        </div>
      </Fragment>
    );
  }

  private clearAllSearchFilters = () => {
    this.setState(
      {
        filters: {
          referenceImage: null,
          eventName: "",
          location: "",
          tags: []
        },
        clearSearch: true
      },
      () => {
        setCookie("reference_image", "");
      }
    );
  };

  private updateImageFilter = (imageURL: string, clearSelfie: boolean) => {
    clearSelfie
      ? this.setState(
          {
            filters: {
              ...this.state.filters,
              referenceImage: imageURL
            },
            selfieUploadPopup: true
          },
          () => {
            deleteCookie("reference_image");
          }
        )
      : this.setState(
          {
            filters: {
              ...this.state.filters,
              referenceImage: imageURL
            },
            selfieUploadPopup: false
          },
          () => {
            setCookie("reference_image", imageURL);
          }
        );
  };

  private toggleSelfieUploadPopup = () => {
    this.setState({
      selfieUploadPopup: !this.state.selfieUploadPopup
    });
  };

  private removeSelfie = () => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          referenceImage: null
        }
      },
      () => {
        setCookie("reference_image", "");
      }
    );
  };

  private updateEventFilter = (name: string) => {
    this.setState({
      filters: {
        ...this.state.filters,
        eventName: name
      }
    });
  };

  private updateLocationFilter = (location: string) => {
    this.setState({
      filters: {
        ...this.state.filters,
        location: location
      }
    });
  };

  private updateTagFilter = (tags: Tag[]) => {
    this.setState({
      filters: {
        ...this.state.filters,
        tags: tags
      }
    });
  };

  private addTagToFilter = (tag: Tag) => {
    this.setState({
      filters: {
        ...this.state.filters,
        tags: [...this.state.filters.tags, tag]
      }
    });
  };

  private removeTag = (index: number) => {
    const updatedTags = this.state.filters.tags;
    updatedTags.splice(index, 1);

    this.setState({
      filters: {
        ...this.state.filters,
        tags: updatedTags
      }
    });
  };

  private keywordFilters = () =>
    _.pick(this.state.filters, ["eventName", "location"]);

  private showUpcomingEvents() {
    this.setState(
      {
        upcomingEventsView: true
      },
      () => history.pushState("upcoming", "", "upcoming")
    );
  }

  private showCompletedEvents() {
    this.setState(
      {
        upcomingEventsView: false
      },
      () => history.pushState("completed", "", "completed")
    );
  }

  private showGetNotifiedPopup(event: Event) {
    this.setState({
      customerSelectedEvent: event
    });
  }

  private eventPath(event: Event) {
    return securedEventPath({
      browsePhotosPath: event.browsePhotosPath,
      organizerUserName: this.props.organizerUserName,
      embedMode: this.props.embedMode,
      cartId: this.props.cartId,
      secureAccessToken: this.props.secureAccessToken || ""
    });
  }

  private noEventsToShow = () =>
    !this.props.completedEventsAvailable &&
    this.props.upcomingEventsCount === 0;

  private imageUploaded = () => !!this.state.filters.referenceImage;

  private tagsApplied = () => this.state.filters.tags.length != 0;

  private showMatchingPhotos = () =>
    (this.props.selfieSearchAvailable && this.imageUploaded()) ||
    this.tagsApplied();
}

export default OrganizationEvents;
